








































































import Vue from "vue";
import { Watch, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import LeftNavigationComponent from "@/components/App/Modules/GMS/Workspace/Components/LeftNavigation.vue";
import ProjectImpact from "./Components/ProjectImapct.vue";
import Progress from './Components/ProjectProgress.vue';
import { AppConstants as _app } from '@/shared/app.constants';
import { MigrationImport,TechnicalReportData } from "@/entities";
import PerformanceReport from './Components/PerformanceReport.vue';
import { Locales } from "@/i18n/locales";

const namespace: string = "migration";

@Component ({
  components: {
      LeftNavigationComponent,
      ProjectImpact,
      Progress,
      PerformanceReport
  }
})
export default class TechnicalReportWorkspaceComponent extends Vue {

    @State(namespace) migration!: MigrationImport;
    @State("technicalReport") technicalReport!: TechnicalReportData;
    @Prop() selectedReport: any;

    // selectedKey: string = Object.keys(this.subSections.properties)[0];
    docTags: any = [];
    showSideBar = true;
    isDirty = false;
    techReports = [];
    actions = _app.actions;
    subjects = _app.subjects;
    enabledStatuses = [_app.techReportStatus.notStarted, _app.techReportStatus.inProgress, _app.techReportStatus.waitingLP];
    techReportpending = _app.techReportStatus.pendingReview;
    ppoAccess:boolean = false;
    initiativeId:number = 0;
    techReportStatus = _app.techReportStatus;
    reportId="";
    sections=_app.migrationTechnicalReportSections;
    selectedKey="impact";
    technicalReportSections=[];
    componentKey=0;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    enableButton() {
        const self = this;
        //@ts-ignore
        if(this.$can(this.actions.update, this.subjects.grantReports) &&
            (self.enabledStatuses.includes(this.technicalReport.selectedReport.WorkFlowStatusId)
            || (self.technicalReport.selectedReport.WorkflowInfo
            && self.technicalReport.selectedReport.WorkflowInfo.CurrentStep
            && self.technicalReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus))
        ) {
            // for applicants
            return true;
        }
        //@ts-ignore
        /*else if(this.$can(this.actions.fullaccess, this.subjects.all) || this.$can(this.actions.manage, this.subjects.program) || this.ppoAccess) {
            // show button for program admins and system admins
            return true;
        }*/
        //@ts-ignore
        // else if(this.$can(this.actions.read, this.subjects.grantReports) && self.technicalReport.selectedReport.WorkFlowStatusId === self.techReportpending)
        //     return true;
    }

    @Watch("initiativeId")
    ppoPermission(val: any) {
        if (val) {
            this.ppoHasPermission(val);
        } else {
            this.ppoAccess = false;
        }
    }

    ppoHasPermission(initiativeId) {
    }

    downloadPdf() {
        let transformedData = this.transformData();
        let option = {
            "schema":this.technicalReportSections,
            "data":transformedData,
            "docTags" :this.technicalReport.documentTags,
            "currency":this.technicalReport.grantInfo.BudgetCurrency,
            "id":this.technicalReport.grantInfo.ApplicationId,
            "type":"",
            "excludeKeys":["summary","performance"]
        };
        this.$services.TechnicalReoprt.generate(option);
    }
    transformData() {
        let data = {};
        for(let key1 in this.grantData[0])
        {
            if(Array.isArray(this.grantData[0][key1])) {
                data[key1] = this.grantData[0][key1];
            } else {
                for(let key2 in this.grantData[0][key1])
                {
                    data[key2] = this.grantData[0][key1][key2];
                }
            }
        }
        data['monitoringPlan'] = this.technicalReport.impact;
        for (let key1 in this.technicalReport.grantInfo)
        {
            data[key1]=this.technicalReport.grantInfo[key1];
        }
        data['reportingPeriod'] = this.technicalReport.selectedReport.Title;

        return data
    }

    get formOptions() {
        return {
            //@ts-ignore
            disableAll: this.$can(this.actions.update, this.subjects.grantReports) && [this.techReportStatus.pendingReview, this.techReportStatus.readyForValidation, this.techReportStatus.approved, this.techReportStatus.terminated].includes(this.technicalReport.selectedReport.WorkFlowStatusId) && this.technicalReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus !== 1 ? true: false,
            locale: this.defaultLocale
        };
    }

    mounted() {
        // this.selectedKey = Object.keys(this.subSections.properties)[0];
    }

    /** Return grant agreement sub sections */
    get subSections() {
        return this.technicalReportSections || {};
    }

    topmenuChanged(key) {
    }

    /** set is-dirty flag  */
    setDirtyFlag(flag: boolean) {
        this.isDirty = flag;
    }


    get grantData() {
        return this.migration.ImportData ;
    }

     get report() {
        return this.selectedReport ;
    }

    get forecastPeriod() {
        let date = "", id = this.technicalReport.selectedReport.TechnicalReportId + 1;
        this.techReports.map((item: any) => {
            if(item.TechnicalReportId == id) {
                date = `${this.$services.format.formatDate(item.StartDate)} - ${this.$services.format.formatDate(item.EndDate)}`;
            }
        });
        return date;
    }


    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    /*** save if form is dirty */
    saveDirty(callback: any) {
        const self = this;

        if(this.isDirty && this.enableButton()) {
            // save the data if form is dirty
            this.setDirtyFlag(false);
            let datum = self.$services.monitor.copyPerformanceReportData(self.technicalReport.grantData)
        }
    }

    /** pre validation action */
    preValidation() {
    }


    validationMessageClicked() {
        this.technicalReport.showValidationDilog = false;
        this.technicalReport.validationMessages = [];
    }

    validationMessageClosed() {
        this.technicalReport.showValidationDilog = false;
        this.technicalReport.validationMessages = [];
    }

    saveData() {
    }


    updateStatus(item) {
    }


    /** computed property workflow items */
    get workFlowItems() {
        return this.technicalReport.selectedReport.WorkflowInfo || {}
    }



    back() {
      this.$emit('back')
    }

     subMenuChanged(selectedMenu, key) {
        this.selectedKey=key;
    }

    get subSchema() {
        return this.sections.properties[this.selectedKey];
    }


    showValidation(e)
    {}

    fileChanged(e)
    {}

    feedbackInfo()
    {}

}
